import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BatchesRoutingModule } from './batches-routing.module';
import { CreateBatchComponent } from './create-batch/create-batch.component';
import { BatchListComponent } from './batch-list/batch-list.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditBatchComponent } from './edit-batch/edit-batch.component';
import { BatchViewComponent } from './batch-view/batch-view.component';
import { MatMenuModule } from '@angular/material/menu';
import { BatchAuditComponent } from './batch-audit/batch-audit.component';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    CreateBatchComponent,
    BatchListComponent,
    EditBatchComponent,
    BatchViewComponent,
    BatchAuditComponent,
  ],
  imports: [
    CommonModule,
    BatchesRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDatatableModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    MatMenuModule,
    NgxSpinnerModule,
  ]
})
export class BatchesModule { }
